import styled from '@emotion/styled'

import Section from '@segment/matcha/recipes/Section'

import TestimonialTemplate from '@segment/templates/Testimonial'

const Testimonial = () => (
  <StyledSection variant="noCopy">
    <TestimonialTemplate variant="extended" company="vacasa" />
  </StyledSection>
)

const StyledSection = styled(Section)`
  max-width: 1260px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding-top: 30px;
    padding-bottom: 30px;
  }
`

export default Testimonial
